import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Button, Form, Dropdown } from 'semantic-ui-react';
import { useCustomers } from '../../../providers/CustomerProvider';
import { useProposals } from '../../../providers/ProposalProvider';
import './ProposalSelectCustomerModal.css';

export const ProposalSelectCustomerModal = ({ open, setOpen }) => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const { setCustomerData } = useProposals();
    const { customersList, getAllCustomers } = useCustomers();
    const navigate = useNavigate();

    useEffect(() => {
        getAllCustomers();
    }, [getAllCustomers]);

    useEffect(() => {
        if (selectedCustomer) {
            navigate('/proposals/create', { selectedCustomer })
        }
    }, [navigate, selectedCustomer]);

    return (
        <>
            <Modal
                size={'tiny'}
                closeIcon
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                style={{ textAlign: 'center' }}
            >
                <Modal.Header>Select Customer</Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Group>
                            <Form.Field
                                label={'Customer'}
                                control={Dropdown}
                                fluid
                                selection
                                options={customersList.map(x => {
                                    const text = (x?.firstname && x?.lastname) ? `${x?.companyName} (${x?.firstname} ${x?.lastname})` : x?.companyName;
                                    return {
                                        key: x?.id,
                                        text: text,
                                        value: x?.id
                                    }
                                })}
                                style={{ height: '38px' }}
                                onChange={(e, selected) => {
                                    const customer = customersList.find(x => x.id === selected.value);
                                    setSelectedCustomer(customer);
                                    setCustomerData(customer);
                                }}
                                width="16"
                                search
                            />
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Link to="/customers/create-customer">
                        <Button>Add Customer</Button>
                    </Link>
                </Modal.Actions>
            </Modal>
        </>
    );
};
